import { ImageFormat } from "@org-avp/ave-message-factory";
import { saveAs } from "file-saver";
export function sleep(milliseconds) {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
}
export function beautifyObject(object) {
    return JSON.stringify(object, undefined, 2);
}
export function isValidFileName(filename) {
    // This regex matches anything consisting upper and lower case letters, numbers and "-" and "_"
    const fileNameRegex = /^[\w-]+$/;
    return fileNameRegex.test(filename);
}
// returns a string that can be used as a src attribute in an html img element, i.e. <img src=...>
export function constructHtmlImgSrc(imageData, imageFormat) {
    const base64Image = arrayBufferToBase64String(imageData);
    const refinedImageFormat = imageFormat === ImageFormat.jpg ? "jpeg" : "png";
    return `data:image/${refinedImageFormat};base64,${base64Image}`;
}
export function arrayBufferToBase64String(arrayBuffer) {
    const uint8Array = new Uint8Array(arrayBuffer);
    return window.btoa(uint8Array.reduce((data, byte) => data + String.fromCharCode(byte), ""));
}
export function saveImage(imageData, imageName, imageFormat) {
    if (imageData) {
        try {
            saveAs(new Blob([imageData]), `${imageName}.${imageFormat}`);
        }
        catch (error) {
            log.error("Could not save image", error);
        }
    }
}
const logPrefix = "[JetStream]:";
export const log = {
    /* eslint-disable no-console */
    debug: (...data) => console.debug(logPrefix, ...data),
    info: (...data) => console.info(logPrefix, ...data),
    warn: (...data) => console.warn(logPrefix, ...data),
    error: (...data) => console.error(logPrefix, ...data),
    /* eslint-enable no-console */
};
export function retrieveUserAgentInformation() {
    const userAgent = {
        mobile: false,
        browser: "undefined",
    };
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        userAgent.mobile = true;
    }
    userAgent.browser = detectUserBrowser();
    return userAgent;
}
export function detectUserBrowser() {
    const agent = navigator.userAgent.toLowerCase();
    if (agent.indexOf("edge") > -1) {
        return "edge";
    }
    if (agent.indexOf("edg") > -1) {
        return "chromium based edge";
    }
    if (agent.indexOf("opr") > -1 && window.opr) {
        return "opera";
    }
    if (agent.indexOf("chrome") > -1 && window.chrome) {
        return "chrome";
    }
    if (agent.indexOf("trident") > -1) {
        return "ie";
    }
    if (agent.indexOf("firefox") > -1) {
        return "firefox";
    }
    if (agent.indexOf("safari") > -1) {
        return "safari";
    }
    return "other";
}
//# sourceMappingURL=utils.js.map